import React from 'react';
import { NavLink } from 'react-router-dom';

const SidebarDashboard = () => {
  return (
    <div className="d-flex flex-md-column justify-content-between sidebar-dashboard bg-dark border-end border-secondary shadow-lg">

      {/* 👑 LOGO / TITRE (Visible uniquement sur ordinateur) */}
      <div className="sidebar-brand p-3 d-none d-md-block text-center border-bottom border-secondary border-opacity-25">
        <h5 className="text-warning fw-semibold mb-0 mt-2 text-uppercase tracking-wider" style={{ fontSize: '1rem' }}>
          📌 Tableau de bord
        </h5>
      </div>

      {/* 🧭 NAVIGATION PRINCIPALE */}
      <nav className="nav flex-row flex-md-column w-100 px-2 py-1 py-md-3 justify-content-around justify-content-md-start gap-1 gap-md-2">

        {/* 🏠 ONGLET TABLEAU DE BORD */}
        <NavLink
          to="/utilisateur/dashboard"
          exact
          className="nav-link-admin d-flex flex-column flex-md-row align-items-center rounded-3 p-2 text-decoration-none nav-link-membre" title='Mon tableau de bord'
          activeClassName="active-admin"
        >
          <i className="bi bi-gear fs-5 me-2"></i>
          <span className="ms-md-3 small-md fw-semibold">Général</span>
        </NavLink>

        {/* ONGLET PROFIL */}
        <NavLink
          to="/utilisateur/profile"
          className="nav-link-admin d-flex flex-column flex-md-row align-items-center rounded-3 p-2 text-decoration-none nav-link-membre" title='Mon profil'
          activeClassName="active-admin"
        >
          <i className="bi bi-person-fill fs-5 me-2"></i>
          <span className="ms-md-3 small-md fw-semibold">Profil</span>
        </NavLink>

        {/* ONGLET CALENDRIER */}
        <NavLink
          to="/utilisateur/calendar"
          className="nav-link-admin d-flex flex-column flex-md-row align-items-center rounded-3 p-2 text-decoration-none nav-link-membre" title='Mon agenda'
          activeClassName="active-admin"
        >
          <i className="bi bi-calendar3 fs-5 me-2"></i>
          <span className="ms-md-3 small-md fw-semibold">Agenda</span>
        </NavLink>

        {/* ONGLET MES NOTES */}
        <NavLink
          to="/utilisateur/note"
          className="nav-link-admin d-flex flex-column flex-md-row align-items-center rounded-3 p-2 text-decoration-none nav-link-membre" title='Mes notes'
          activeClassName="active-admin"
        >
          <i className="bi bi-file-earmark-text-fill fs-5 me-2"></i>
          <span className="ms-md-3 small-md fw-semibold">Notes</span>
        </NavLink>

        {/* ONGLET MES ACTIONS */}
        <NavLink
          to="/actions"
          className="nav-link-admin d-flex flex-column flex-md-row align-items-center rounded-3 p-2 text-decoration-none nav-link-membre" title='Mes actions'
          activeClassName="active-admin"
        >
          <i className="bi bi-file-earmark-text-fill fs-5 me-2"></i>
          <span className="ms-md-3 small-md fw-semibold">Actions</span>
        </NavLink>

      </nav>

      {/* 👤 DISCRET RAPPEL BAS (Visible uniquement sur ordinateur) */}
      <div className="p-3 d-none d-md-block border-top border-secondary border-opacity-25 text-center text-light small">
        ⚡ v2.0
      </div>

    </div>
  );
};

export default SidebarDashboard;
